import type { SVGProps } from "react";
export interface PenEditIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PenEditIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PenEditIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18V6A4.125 4.125 0 0 1 6 1.875h3a1.125 1.125 0 0 1 0 2.25H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.036.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875v-3a1.125 1.125 0 0 1 2.25 0v3A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18M14.832 3.832a1.125 1.125 0 0 1 1.505-.078l.085.078 3.75 3.75.078.085a1.126 1.126 0 0 1-1.584 1.582l-.085-.076-3.75-3.75-.077-.087a1.124 1.124 0 0 1 .078-1.504"
      />
      <path
        fill={color}
        d="M17.102 1.579a3.126 3.126 0 0 1 4.183.215l.92.921.216.238a3.126 3.126 0 0 1-.215 4.182L13.81 15.53a4.1 4.1 0 0 1-1.925 1.087l-.315.065-2.17.361A2.125 2.125 0 0 1 6.954 14.6l.362-2.171a4.13 4.13 0 0 1 1.152-2.24l8.396-8.395.237-.215Zm2.592 1.806a.876.876 0 0 0-1.1-.113l-.138.113-8.395 8.396c-.276.277-.46.632-.525 1.017l-.333 1.998 1.999-.332c.385-.065.74-.249 1.017-.525l8.396-8.395a.876.876 0 0 0 .113-1.1l-.113-.138z"
      />
    </svg>
  );
}
